  <div class="py-2">
    <!-- Main Expenses Section -->
    <div class="signio-divider-header" @click="toggle('main_expenses')">
      <span class="chevron">{{ collapsed_sections.main_expenses ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Main Expenses</label>
    </div>
    <transition name="fade">
      <div v-show="!collapsed_sections.main_expenses">
        <!-- Housing & Property -->
        <div class="category-title">Housing & Property</div>
        <div class="row g-3">
          <div v-for="field in housing_fields" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Utilities -->
        <div class="category-title mt-3">Utilities</div>
        <div class="row g-3">
          <div v-for="field in utilities_fields" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Loans & Credit -->
        <div class="category-title mt-3">Loans & Credit</div>
        <div class="row g-3">
          <div v-for="field in loans_fields" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Instalments & Accounts -->
        <div class="category-title mt-3">Instalments & Accounts</div>
        <div class="row g-3">
          <div v-for="field in install_fields" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Other Expenses -->
        <div class="category-title mt-3">Other Expenses</div>
        <div class="row g-3">
          <div v-for="field in other_fields" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Totals -->
        <div class="category-title mt-3 d-none">Totals</div>
        <div class="row g-3 d-none">
          <div v-for="field in totals_fields" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <div class="row g-3 mt-3 d-none">
          <div v-for="field in main_text_fields" :key="field.key" class="col-sm-12 mb-3">
            <label class="form-label text-xs mb-1">{{ field.question }}</label>
            <input
              type="text"
              class="form-control"
              :id="field.key"
              v-model="form_data[field.key]" />
          </div>
        </div>
      </div>
    </transition>
    <!-- Spouse Expenses Section -->
    <div class="signio-divider-header mt-4" v-if="is_married" @click="toggle('spouse_expenses')">
      <span class="chevron">{{ collapsed_sections.spouse_expenses ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Spouse Expenses</label>
    </div>
    <transition name="fade" v-if="is_married" >
      <div v-show="!collapsed_sections.spouse_expenses">
        <!-- Spouse Housing & Property -->
        <div class="category-title">Housing & Property</div>
        <div class="row g-3">
          <div v-for="field in spouse_housing" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Spouse Utilities -->
        <div class="category-title mt-3">Utilities</div>
        <div class="row g-3">
          <div v-for="field in spouse_utilities" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Spouse Loans & Credit -->
        <div class="category-title mt-3">Loans & Credit</div>
        <div class="row g-3">
          <div v-for="field in spouse_loans" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Spouse Instalments & Accounts -->
        <div class="category-title mt-3">Instalments & Accounts</div>
        <div class="row g-3">
          <div v-for="field in spouse_installs" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Spouse Other Expenses -->
        <div class="category-title mt-3">Other Expenses</div>
        <div class="row g-3">
          <div v-for="field in spouse_other" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <!-- Spouse Totals -->
        <div class="category-title mt-3 d-none">Totals</div>
        <div class="row g-3 d-none">
          <div v-for="field in spouse_totals" :key="field.key" class="col-md-4 mb-3">
            <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
            <div class="mt-1">
              <div class="currency-input-group" tabindex="-1">
                <span class="currency-prefix">R</span>
                <input
                  type="text"
                  class="currency-input"
                  :id="field.key"
                  v-model="form_data[field.key]"
                  @input="allow_currency"
                  @blur="format_amount(field)"
                  placeholder="0.00"
                  inputmode="decimal"
                  step="0.01"
                  min="0" />
              </div>
            </div>
          </div>
        </div>
        <div class="row g-3 mt-3 d-none">
          <div v-for="field in spouse_text_fields" :key="field.key" class="col-sm-12 mb-3">
            <label class="form-label text-xs mb-1">{{ field.question }}</label>
            <input
              type="text"
              class="form-control"
              :id="field.key"
              v-model="form_data[field.key]" />
          </div>
        </div>
      </div>
    </transition>
    <!-- Submit button -->
    <div class="text-end mt-4">
      <button type="button" @click="previous" class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-1">
        Previous
      </button>
      <button type="button" @click="submit_section" class="btn btn-bg-green text-xs rounded-small shadow-sm">
        Continue
      </button>
    </div>
  </div>